const KEYCODES = Object.freeze({
    backspace: 8,
    delete: 46,
    downArrow: 40,
    enter: 13,
    escape: 27,
    leftArrow: 37,
    rightArrow: 39,
    space: 32,
    tab: 9,
    upArrow: 38
});

export {KEYCODES};
